import { GridSortModel } from '@mui/x-data-grid';

import { RecordListOrder, RecordListSort } from '../../../types/syntiro_honey';

/** The columns the backend allows sorting by (whitelisted to avoid arbitrary sort). */
export const SORTABLE_FIELDS: Array<RecordListSort> = [
  'createdAt',
  'overallConfidence',
  'rawLabel'
];

/**
 * Maps a data-grid sort model onto the backend's whitelisted sort/order params,
 * returning an empty object when the active sort is not a supported column.
 * @param {GridSortModel} model The grid's current sort model.
 * @returns {{ sort?: RecordListSort; order?: RecordListOrder }}
 */
export function toSortQuery(model: GridSortModel): {
  sort?: RecordListSort;
  order?: RecordListOrder;
} {
  const entry = model[0];
  const field = SORTABLE_FIELDS.find((candidate) => candidate === entry?.field);
  if (entry === undefined || field === undefined || entry.sort == null) {
    return {};
  }
  return { sort: field, order: entry.sort };
}
